import PropTypes from "prop-types";
import React, { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../../common/Auth"
import ModalVideo from "react-modal-video";
import ProductImageVideoEditIcon from "../../pages/productImageVideo/ProductImageVideoEditIcon"

const VideoPopup = () => {

  const { themeSettingsData } = useContext(AuthContext)
  const [modalStatus, isOpen] = useState(false);
  const [productData, setProductData] = useState({})
  const [productId, setProductId] = useState("")

  useEffect(() => {
    themeSettingsData.map((i) => {
      if (i.settingsName === "productImageWithVideo") {
        setProductData(i.values[0]);
        setProductId(i._id);
      }
    })
  }, [themeSettingsData])



  let linkStyle = {
    color: productData.linkTextColor,
  }

  let pt = productData.paddingTop ? productData.paddingTop : "pt-50";
  let pb = productData.paddingBottom ? productData.paddingBottom : "pb-50";
  let mb = productData.marginBottom ? productData.marginBottom : "mt-50";
  let mt = productData.marginTop ? productData.marginTop : "mb-50";
  let bgImage = productData?.bgImage ? productData?.bgImage : "";
  let bgColor = productData?.bgColor ? productData?.bgColor : "";

  return (
    <div className={`antera-video-popup-section-container video-popup section-bgImage ${pt} ${pb} ${mb} ${mt}`} style={(bgImage.length > 0 ) ? {backgroundImage:`url(${bgImage})`} : {background:bgColor}} >
      <div className="antera-video-popup-content-container container">
        <div className="edit-inline">
          <ProductImageVideoEditIcon productId={productId} fromEditAction="topBottomspace" />
        </div>
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="video-popup__image">
              <div className="edit-inline">
                <ProductImageVideoEditIcon productId={productId} fromEditAction="image" />
              </div>
              {productData.image && (
                <img
                  src={productData.image}
                  alt=""
                  className="antera-video-popup-image img-fluid"
                />
              )}

            </div>
          </div>
          <div className="col-lg-6">
            <div className="video-popup__content">
              <div className="edit-inline">
                <ProductImageVideoEditIcon productId={productId} fromEditAction="title" />
              </div>
              <h2 className="title mb-30" dangerouslySetInnerHTML={{ __html: productData.title }}>

              </h2>
              <div className="edit-inline" >
                <ProductImageVideoEditIcon productId={productId} fromEditAction="description" />
              </div>
              <p className="text mb-30" dangerouslySetInnerHTML={{ __html: productData.description }} >

              </p>
              <div className="edit-inline">
                <ProductImageVideoEditIcon productId={productId} fromEditAction="link" />
              </div>
              {productData.linkText && (
                <div className="antera-video-popup-link-container link mb-30">
                  <Link to={process.env.PUBLIC_URL + productData.link} style={linkStyle}>
                    {productData.linkText}
                  </Link>
                </div>
              )}


              <ModalVideo
                channel={productData.channel}
                isOpen={modalStatus}
                videoId={productData.videoId}
                onClose={() => isOpen(false)}
              />

              <div className="edit-inline">
                <ProductImageVideoEditIcon productId={productId} fromEditAction="video" />
              </div>

              {(productData.videoId && productData.channel) && (
                <button className="antera-video-popup-button" onClick={() => isOpen(true)}>
                  <i className="fa fa-play-circle"></i>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

VideoPopup.propTypes = {};

export default VideoPopup;
